import createTransition from 'shared-tokens/utils/createTransition';
import createBreakpoint from 'shared-tokens/utils/breakpoints';

const brDesktop = createBreakpoint('m');

export const mainCls = 'box-header-srp-tags-cnt';

export default {
  [mainCls]: {
    display: 'flex',
    margin: 0,
    padding: 0,
    flexWrap: 'wrap',
    flexDirection: 'row',
    [brDesktop]: {
      marginTop: '16px',
    },
  },
  [`${mainCls}__not-show-on-mobile`]: {
    display: 'none',
    [brDesktop]: {
      display: 'flex',
    },
  },
  [`${mainCls}__not-show-on-desktop`]: {
    display: 'flex',
    rowGap: '16px',
    [brDesktop]: {
      display: 'none',
    },
  },
};
